import React from 'react'
import Media from 'react-bootstrap/Media'
import CardGroup from 'react-bootstrap/CardGroup'
import Card from 'react-bootstrap/Card'
import Divider from './Divider'
import ArticleCell from './ArticleCell'
import { Default, Mobile }  from './ViewTypes'
import { print } from '../managers/Logger'

export default class ArticleSection extends React.Component { 

	getTitle() { 
		if (this.props.title !== undefined) { 
			return this.props.title
		} else {
			return "Editorial"
		}
	}

	getDivider() { 
		if (this.props.noDivider !== true) { 
			return <Divider />
		}
	}

	render() { 
		if (this.props.articles == undefined || this.props.articles == null || this.props.articles.map == undefined ||
			this.props.articles.length === 0) { 
			return null
		}
		print(this.props.articles)

		return (
			<div style={{...{paddingTop:20}, ...this.props.style}}>
				<h3 style={{marginBottom:20}}>{this.getTitle()}</h3>
				<Mobile>
					<div style={{display: 'flex', flexWrap: 'nowrap', overflowX: 'auto'}}>
					{this.props.articles.map((item, index) => 
						<ArticleCell 
							article={item}
							key={index}
							onClicked={(id) => this.props.onClicked(id)}
							horizontal/>
						)
					}
					</div>
				</Mobile>
				<Default>
					<CardGroup style={{marginRight:10}}>
					{this.props.articles.map((item, index) => 
						<ArticleCell 
							article={item}
							key={index}
							onClicked={(id) => this.props.onClicked(id)}/>
						)
					}
					</CardGroup>
				</Default>
				{this.getDivider()}
			</div>
			)
	}
}    
